module.exports = __webpack_public_path__ + "./assets/img/portfolio_4.36c789ac.jpg";